<nz-modal [(nzVisible)]="visible" nzTitle="An existing BIR Info record was found with the same TIN details:"
  (nzOnCancel)="visible = false" (nzOnOk)="handleOk()" nzOkText="Use this BIR">
  <ng-container *nzModalContent>
    <app-bir-info-view [data]="data"></app-bir-info-view>
  </ng-container>
</nz-modal>
